import { mapGetters, mapActions } from 'vuex'

export const nameListComputed = {
  ...mapGetters('nameList', ['getNameList']),
}

export const nameListMethods = mapActions('nameList', ['fetchingNameList'])
